<template>
  <input-text v-bind="$attrs"
    ref="campo"
    v-model="model"
    v-mask="mask"
    maxlength="20"
      type="tel"
      pattern="[0-9]*"
    :format="type"
    :documento-invalido="invalido"
    v-on="listeners">
  <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
    <slot :name="slotName" v-bind="context" />
  </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </input-text>
</template>

<script>
export default {
  props: {
    value: null,
    cpf: { type: Boolean, default: false },
    cnpj: { type: Boolean, default: false },
    validate: { type: Boolean, default: true },
  },
  data () {
    return {
      listeners: {},
      invalido: false,
    };
  },
  computed: {
    mask: function () {
      const masks = []
      if (this) {
        if (!this.cpf || this.cnpj) {
          masks.push('##.###.###/####-##')
        }
        if (!this.cnpj || this.cpf) {
          masks.push('###.###.###-##')
        }
      }
      return masks;
    },
    type: function () {
      if (this) {
        if (this.cpf === this.cnpj) {
          return 'doc'
        } else if (this.cpf || !this.cnpj) {
          return 'cpf'
        } else if (this.cnpj || !this.cpf) {
          return 'cnpj'
        }
      }
      return 'doc'
    },
    model: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    changeDefault: function () {
      const th = this
      if (th.validate) {
        th.change(th.value, isValid => th.$emit('change', th.value, isValid))
      } else { th.$emit('change', th.value) }
    },
    change (value, callback) {
      if (!callback || typeof callback !== 'function') {
        callback = () => {}
      }
      const th = this
      if (value) {
        th.$api.UTIL.Functions.ValidaDocumento(
          th.$api.UI.Format.SomenteNumeros(value)
        ).then(function (isValid) {
          th.invalido = !isValid
          callback(isValid)
        })
      } else {
        callback()
      }
    }
  },
  created () {
    this.listeners = { ...this.$listeners, change: this.changeDefault }
  }
}
</script>
